import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { formDataHeaders, requests } from "../../utils/api/api.service";
import { EMAIL_LIST_URL } from "../../utils/api/endpoints";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import {
  IEmailList,
  IEmailRecipient,
  IEmailStats,
} from "../../shared/interfaces/email-list/IEmailList";

export const AdminEmailListService = {
  get: (pagination: IPagination): Promise<IBaseModel<IEmailList[]>> =>
    requests.get(EMAIL_LIST_URL, pagination),
  stats: (id: string): Promise<IEmailStats> =>
    requests.get(`${EMAIL_LIST_URL}/${id}/stats`),
  send: (emailListId: number): Promise<{ queued: number }> =>
    requests.post(`${EMAIL_LIST_URL}/send`, { emailListId }),
  getSingle: (id: string): Promise<IEmailList> =>
    requests.get(`${EMAIL_LIST_URL}/${id}`),
  upload: (formData: FormData) =>
    requests.post(`${EMAIL_LIST_URL}/upload`, formData, formDataHeaders),

  addRecipient: (payload: IEmailRecipient, emailListId: string) =>
    requests.post(`${EMAIL_LIST_URL}/add-recipient/${emailListId}`, {
      recipients: [payload],
    }),
};
